import actions from '../../feature/ecom/actions/texts.js';
import minicart from './cart/CartPopper/texts.js';
import cart from './cart/texts.js';
import catalog from './catalog/texts.js';
import checkout from './checkout/texts.js';
import components from './components/texts.js';
import order from './orders/text.js';
import part from './part/text.js';
import punchout from './punchout/texts.js';
import recommendation from './recommendation/text.js';
import search from './search/texts.js';
import shoppingLists from './shoppinglists/texts.js';
import sidebar from './sidebarText.js';

export default {
  components,
  actions,
  cart,
  minicart,
  catalog,
  checkout,
  order,
  part,
  punchout,
  recommendation,
  search,
  sidebar,
  shoppingLists,
  availability: {
    local: {
      label: {
        notes: 'Label for articles available at local level',
        message: 'Local',
      },
    },
    national: {
      label: {
        notes: 'Label for articles available at national level',
        message: 'National',
      },
    },
    global: {
      label: {
        notes: 'Label for articles available at global level',
        message: 'Global',
      },
    },
    notAvailable: {
      label: {
        notes:
          'Label when there is no availability (neither locally, nationally or globally) for the articles',
        message: '-',
      },
      tooltip: {
        notes:
          'Tooltip to contact customer sales representative to get information about delivery time',
        message:
          'Please contact your CSSR for more information on delivery time.',
      },
    },
    deliveryDate: {
      inconsistent: {
        notes:
          'Text to display when there are both items with delivery date, and items with unknown date',
        message: 'Multiple',
      },
      disclaimer: {
        notes:
          'Disclaimer text to display in the tooltip for delivery dates together with detailed dates',
        message: 'Delivery dates based on standard freight option',
      },
    },
  },
  price: {
    notAvailable: {
      label: {
        notes: 'Label when there is no price available for the article',
        message: '-',
      },
      tooltip: {
        notes:
          'Tooltip to contact customer sales representative to update price information',
        message: 'Please contact your CSSR to update pricing.',
      },
    },
  },
  relatedArticles: {
    header: {
      notes: 'Header for related parts',
      message: 'Related parts',
    },
  },
  deliveryPoint: {
    filterPlaceholder: {
      notes: 'Placeholder for filter input',
      message: 'Filter',
    },
    addressMissing: {
      notes: 'Fallback text when there are no address',
      message: 'unknown address',
    },
  },
};
